// extracted by mini-css-extract-plugin
export default {"channel_title":"VideoCard_channel_title__Myax+"};